var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamondLeague(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 186,
    viewBox: "0 0 186 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8418_9494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.0001 185.652C144.167 185.652 185.652 144.167 185.652 92.9996C185.652 41.8326 144.167 0.347656 93.0001 0.347656C41.8331 0.347656 0.348145 41.8326 0.348145 92.9996C0.348145 144.167 41.8331 185.652 93.0001 185.652Z",
    fill: "white",
    stroke: "#0F0F0F",
    strokeWidth: 1.04408,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9978 4.31445C44.0163 4.31445 4.3064 44.0244 4.3064 93.0059C4.3064 141.987 44.0163 181.697 92.9978 181.697C141.979 181.697 181.689 141.987 181.689 93.0059C181.689 44.0244 141.979 4.31445 92.9978 4.31445ZM80.2948 137.609C42.9027 112.614 1.1115 66.507 33.8052 33.8133C66.4989 1.11956 119.497 1.11956 152.19 33.8133C178.752 60.3748 181.794 99.4931 167.128 131.936C158.517 150.98 118.731 163.301 80.2948 137.609Z",
    fill: "#4D99FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9978 4.31445C44.0163 4.31445 4.3064 44.0244 4.3064 93.0059C4.3064 141.987 44.0163 181.697 92.9978 181.697C141.979 181.697 181.689 141.987 181.689 93.0059C181.689 44.0244 141.979 4.31445 92.9978 4.31445ZM80.2948 137.609C42.9027 112.614 1.1115 66.507 33.8052 33.8133C66.4989 1.11956 119.497 1.11956 152.19 33.8133C178.752 60.3748 181.794 99.4931 167.128 131.936C158.517 150.98 118.731 163.301 80.2948 137.609Z",
    fill: "url(#paint0_angular_8418_9494)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7131 174.12C84.1307 172.199 80.191 169.721 74.9288 168.586C69.6597 167.452 65.0588 168.092 64.6481 170.02C64.2374 171.941 68.1701 174.419 73.4323 175.554C78.6945 176.688 83.3024 176.048 83.7131 174.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.847 27.8359C174.39 48.7872 47.6034 100.609 10.5593 96.3487C0.939792 95.242 0.529119 91.351 0.431671 89.5621C0.389908 90.7037 0.348145 91.8452 0.348145 93.0007C0.348145 117.808 10.1208 140.325 25.9978 156.954C48.9955 174.049 182.388 122.089 185.61 94.8174C185.624 94.2118 185.659 93.6062 185.659 93.0007C185.659 67.5877 175.42 44.5761 158.854 27.8359H158.847Z",
    fill: "#0F0F0F",
    stroke: "#0F0F0F",
    strokeWidth: 1.04408,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3095 116.099C15.9035 113.085 12.4302 109.208 8.47656 105.707C11.3374 116.482 14.7759 126.992 19.4116 137.141C23.8803 141.234 28.7944 144.749 33.7573 148.201C31.8223 144.401 29.9986 140.538 28.2654 136.633C33.4719 140.224 38.6993 143.781 44.226 146.872C50.6923 145.89 57.11 144.394 63.4371 142.772C55.516 138.951 47.8455 134.663 40.2306 130.278C35.8107 131.503 31.335 132.484 26.8594 133.452C24.4232 127.765 22.2933 121.967 20.3025 116.106L20.3095 116.099Z",
    fill: "#4D99FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3095 116.099C15.9035 113.085 12.4302 109.208 8.47656 105.707C11.3374 116.482 14.7759 126.992 19.4116 137.141C23.8803 141.234 28.7944 144.749 33.7573 148.201C31.8223 144.401 29.9986 140.538 28.2654 136.633C33.4719 140.224 38.6993 143.781 44.226 146.872C50.6923 145.89 57.11 144.394 63.4371 142.772C55.516 138.951 47.8455 134.663 40.2306 130.278C35.8107 131.503 31.335 132.484 26.8594 133.452C24.4232 127.765 22.2933 121.967 20.3025 116.106L20.3095 116.099Z",
    fill: "url(#paint1_angular_8418_9494)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7599 95.763C73.7715 109.482 79.2634 123.041 84.6091 136.628C88.5975 135.403 92.5302 134.025 96.4768 132.682C94.0893 126.292 91.6671 119.923 89.21 113.554C96.1497 118.301 103.131 122.979 110.106 127.677C114.783 125.826 119.433 123.932 124.089 122.032C116.468 116.958 108.846 111.884 101.224 106.809C103.785 97.9973 106.208 89.1505 108.456 80.2549C103.709 82.169 98.9339 84.0205 94.1659 85.8999C92.0917 93.821 89.9269 101.721 87.6856 109.594C85.333 103.454 82.9525 97.3291 80.565 91.2108C76.6392 92.7491 72.6926 94.2456 68.7529 95.763H68.7599Z",
    fill: "#4D99FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7599 95.763C73.7715 109.482 79.2634 123.041 84.6091 136.628C88.5975 135.403 92.5302 134.025 96.4768 132.682C94.0893 126.292 91.6671 119.923 89.21 113.554C96.1497 118.301 103.131 122.979 110.106 127.677C114.783 125.826 119.433 123.932 124.089 122.032C116.468 116.958 108.846 111.884 101.224 106.809C103.785 97.9973 106.208 89.1505 108.456 80.2549C103.709 82.169 98.9339 84.0205 94.1659 85.8999C92.0917 93.821 89.9269 101.721 87.6856 109.594C85.333 103.454 82.9525 97.3291 80.565 91.2108C76.6392 92.7491 72.6926 94.2456 68.7529 95.763H68.7599Z",
    fill: "url(#paint2_angular_8418_9494)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.365 121.057C121.757 106.948 116.433 93.0481 110.788 79.3219C114.588 77.7906 118.382 76.2523 122.175 74.707C127.827 88.2871 133.013 102.048 137.391 116.094C133.764 117.862 130.047 119.422 126.358 121.057H126.365Z",
    fill: "#4D99FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.365 121.057C121.757 106.948 116.433 93.0481 110.788 79.3219C114.588 77.7906 118.382 76.2523 122.175 74.707C127.827 88.2871 133.013 102.048 137.391 116.094C133.764 117.862 130.047 119.422 126.358 121.057H126.365Z",
    fill: "url(#paint3_angular_8418_9494)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.149 83.2045C131.569 83.8727 133.136 83.9006 134.576 83.2811C136.045 82.6337 137.124 81.4713 137.653 79.9539C138.126 78.3739 138.029 76.7242 137.381 75.2068C136.783 73.6755 135.683 72.4574 134.214 71.7126C132.801 71.0374 131.242 70.9957 129.788 71.5873C128.326 72.2068 127.247 73.3553 126.697 74.8449C126.168 76.4388 126.231 78.1163 126.885 79.6685C127.504 81.2277 128.639 82.4667 130.143 83.2115L130.149 83.2045ZM129.794 87.172C133.386 96.36 136.609 105.68 139.546 115.098C142.999 113.546 146.368 111.771 149.743 110.058C147.133 100.745 143.827 91.5711 140.34 82.5572C136.839 84.1303 133.323 85.6616 129.794 87.172Z",
    fill: "#4D99FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.149 83.2045C131.569 83.8727 133.136 83.9006 134.576 83.2811C136.045 82.6337 137.124 81.4713 137.653 79.9539C138.126 78.3739 138.029 76.7242 137.381 75.2068C136.783 73.6755 135.683 72.4574 134.214 71.7126C132.801 71.0374 131.242 70.9957 129.788 71.5873C128.326 72.2068 127.247 73.3553 126.697 74.8449C126.168 76.4388 126.231 78.1163 126.885 79.6685C127.504 81.2277 128.639 82.4667 130.143 83.2115L130.149 83.2045ZM129.794 87.172C133.386 96.36 136.609 105.68 139.546 115.098C142.999 113.546 146.368 111.771 149.743 110.058C147.133 100.745 143.827 91.5711 140.34 82.5572C136.839 84.1303 133.323 85.6616 129.794 87.172Z",
    fill: "url(#paint4_angular_8418_9494)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.194 58.7283C165.7 70.603 170.238 83.0624 173.245 95.8141C175.027 94.4011 176.85 93.0508 178.5 91.4847C177.693 87.6842 176.732 83.9116 175.625 80.1877C177.512 83.0624 179.53 85.9301 180.985 89.0485C182.14 87.8513 183.115 86.5288 183.922 85.081C182.502 81.6981 180.874 78.6007 178.904 75.5102C178.674 71.3339 178.152 67.2967 177.449 63.1761C176.266 64.081 175.041 64.9371 173.781 65.7376C174.108 69.4197 174.4 73.1088 174.581 76.7979C172.305 69.6912 169.507 62.7515 166.298 56.0137C164.273 56.9394 162.24 57.8443 160.194 58.7283Z",
    fill: "#4D99FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.194 58.7283C165.7 70.603 170.238 83.0624 173.245 95.8141C175.027 94.4011 176.85 93.0508 178.5 91.4847C177.693 87.6842 176.732 83.9116 175.625 80.1877C177.512 83.0624 179.53 85.9301 180.985 89.0485C182.14 87.8513 183.115 86.5288 183.922 85.081C182.502 81.6981 180.874 78.6007 178.904 75.5102C178.674 71.3339 178.152 67.2967 177.449 63.1761C176.266 64.081 175.041 64.9371 173.781 65.7376C174.108 69.4197 174.4 73.1088 174.581 76.7979C172.305 69.6912 169.507 62.7515 166.298 56.0137C164.273 56.9394 162.24 57.8443 160.194 58.7283Z",
    fill: "url(#paint5_angular_8418_9494)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.325 81.6682C145.833 90.6612 148.958 99.7656 151.603 109.051C154.631 107.401 157.603 105.731 160.569 103.977C159.274 99.1949 157.777 94.4617 156.246 89.7494C156.037 89.1438 155.954 88.5034 155.995 87.8631C156.03 87.2993 156.197 86.7563 156.49 86.2691C156.775 85.8236 157.172 85.4617 157.638 85.2181C158.292 84.87 159.009 84.8491 159.678 85.1624C160.429 85.6426 160.931 86.3805 161.146 87.2645C162.622 91.8654 163.979 96.5011 165.211 101.172C167.515 99.7795 169.715 98.2413 171.935 96.7308C170.599 91.3782 169.074 86.0672 167.334 80.8329C166.868 79.1485 166.06 77.6032 164.926 76.2877C163.972 75.2018 162.726 74.471 161.313 74.1577C159.921 73.8793 158.501 74.0742 157.234 74.7146C155.536 75.3619 154.095 76.5104 153.288 78.1253C153.065 78.9884 153.051 79.9002 153.239 80.7772L153.163 80.9095L152.87 80.8051C152.334 79.7192 151.979 78.5359 151.812 77.3248C148.666 78.8004 145.513 80.2552 142.332 81.6682H142.325ZM153.246 81.1531H153.253V81.1322C153.246 81.1113 153.232 81.0974 153.218 81.0904C153.225 81.0348 153.218 80.986 153.204 80.9304V80.9164L153.183 80.9025H153.149L153.135 80.9164C153.135 81 153.163 81.0765 153.218 81.1392H153.239L153.246 81.1531ZM156.239 89.7424C156.239 89.7424 156.239 89.7563 156.239 89.7633C156.239 89.7633 156.232 89.7494 156.232 89.7424H156.239Z",
    fill: "#4D99FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.325 81.6682C145.833 90.6612 148.958 99.7656 151.603 109.051C154.631 107.401 157.603 105.731 160.569 103.977C159.274 99.1949 157.777 94.4617 156.246 89.7494C156.037 89.1438 155.954 88.5034 155.995 87.8631C156.03 87.2993 156.197 86.7563 156.49 86.2691C156.775 85.8236 157.172 85.4617 157.638 85.2181C158.292 84.87 159.009 84.8491 159.678 85.1624C160.429 85.6426 160.931 86.3805 161.146 87.2645C162.622 91.8654 163.979 96.5011 165.211 101.172C167.515 99.7795 169.715 98.2413 171.935 96.7308C170.599 91.3782 169.074 86.0672 167.334 80.8329C166.868 79.1485 166.06 77.6032 164.926 76.2877C163.972 75.2018 162.726 74.471 161.313 74.1577C159.921 73.8793 158.501 74.0742 157.234 74.7146C155.536 75.3619 154.095 76.5104 153.288 78.1253C153.065 78.9884 153.051 79.9002 153.239 80.7772L153.163 80.9095L152.87 80.8051C152.334 79.7192 151.979 78.5359 151.812 77.3248C148.666 78.8004 145.513 80.2552 142.332 81.6682H142.325ZM153.246 81.1531H153.253V81.1322C153.246 81.1113 153.232 81.0974 153.218 81.0904C153.225 81.0348 153.218 80.986 153.204 80.9304V80.9164L153.183 80.9025H153.149L153.135 80.9164C153.135 81 153.163 81.0765 153.218 81.1392H153.239L153.246 81.1531ZM156.239 89.7424C156.239 89.7424 156.239 89.7563 156.239 89.7633C156.239 89.7633 156.232 89.7494 156.232 89.7424H156.239Z",
    fill: "url(#paint6_angular_8418_9494)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3633 108.168C39.303 106.824 43.187 109.838 44.5165 113.472C45.8598 117.049 44.7531 121.664 40.8204 122.966C36.9225 124.045 33.3169 121.226 31.9805 117.683C30.6441 114.14 31.7508 109.796 35.3564 108.161L35.3633 108.168Z",
    fill: "#4D99FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3633 108.168C39.303 106.824 43.187 109.838 44.5165 113.472C45.8598 117.049 44.7531 121.664 40.8204 122.966C36.9225 124.045 33.3169 121.226 31.9805 117.683C30.6441 114.14 31.7508 109.796 35.3564 108.161L35.3633 108.168Z",
    fill: "url(#paint7_angular_8418_9494)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_8418_9494",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(181.689 4.31445) rotate(116.565) scale(198.32 304.366)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#E8B5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD5C9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_8418_9494",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.4371 105.707) rotate(122.89) scale(50.6055 88.5365)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#E8B5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD5C9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_angular_8418_9494",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124.089 80.2549) rotate(116.142) scale(62.7974 95.2982)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#E8B5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD5C9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_angular_8418_9494",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.391 74.707) rotate(106.012) scale(48.2212 49.0557)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#E8B5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD5C9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_angular_8418_9494",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(149.743 71.1729) rotate(104.916) scale(45.4566 43.3801)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#E8B5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD5C9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_angular_8418_9494",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(183.922 56.0137) rotate(106.599) scale(41.5312 43.6239)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#E8B5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD5C9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_angular_8418_9494",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(171.935 74.0342) rotate(112.919) scale(38.018 52.3201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#E8B5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD5C9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_angular_8418_9494",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.0614 107.842) rotate(113.927) scale(16.801 23.8973)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#E8B5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD5C9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8418_9494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 186.007,
    height: 186,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondLeague);
export default __webpack_public_path__ + "static/media/DiamondLeague.5190db7af7d8f873ea4801a304a4e9d8.svg";
export { ForwardRef as ReactComponent };